module.exports = __webpack_public_path__ + "img/e03794d3c7ca860379efdbfca0381b9c.png"


//////////////////
// WEBPACK FOOTER
// ./app/images/button-italic-small.png
// module id = 476
// module chunks = 0